import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface QuestionnaireResponseState {
  questionnaireResponses: Record<string, QuestionnaireResponse | undefined>;
}

const initialState: QuestionnaireResponseState = {
  questionnaireResponses: {},
};

export const questionnaireResponseSlice = createSlice({
  name: "questionnaireResponses",
  initialState,
  reducers: {
    setNewbornIPPQuestionnaireResponses: (
      state,
      action: PayloadAction<Record<string, QuestionnaireResponse | undefined>>,
    ) => {
      state.questionnaireResponses = action.payload;
    },
    updateNewbornIPPQuestionnaireResponse: (
      state,
      action: PayloadAction<{
        questionnaireName: string;
        questionnaireResponse: QuestionnaireResponse | undefined;
      }>,
    ) => {
      state.questionnaireResponses[action.payload.questionnaireName] =
        action.payload.questionnaireResponse;
    },
  },
});

export const { setNewbornIPPQuestionnaireResponses, updateNewbornIPPQuestionnaireResponse } =
  questionnaireResponseSlice.actions;

// Selectors
export const selectAllNewbornIPPQuestionnaireResponses = (state: RootState) =>
  state.newbornIPP.questionnaireResponses;

export const selectNewbornIPPQuestionnaireResponseByQuestionnaireName = (
  state: RootState,
  questionnaireName: string,
) => state.newbornIPP.questionnaireResponses[questionnaireName];

export default questionnaireResponseSlice.reducer;
